import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from './svg/wait2.gif'

import { BkInfo } from './Types'
import { SystemHeader } from './CommonUI';

import i18next from 'i18next';


interface PageInfo {
    n: number
}

var GsbFlag: any;


interface BkMastViewProps {
    gsb: AxiosInstance,
    Bkr: BkInfo,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
}


function BkMastView({ gsb, Bkr = {} as BkInfo, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { } }: BkMastViewProps) {

    const [isAdd, setisAdd] = useState(false)
    const [isEdit, setisEdit] = useState(false)
    const [isDelete, setisDelete] = useState(false)

    const { t, i18n } = useTranslation();    

    if (! ("d_bkCode" in Bkr)) return null

    function buttonPress(buttonName: string)
    {
        if ( buttonName == "new" )
        {
            onNew()
        }
        if ( buttonName == "edit" )
        {
            onEdit()
        }
        if ( buttonName == "delete" )
        {
            setisDelete(true)
        }
    }

    return (
        <div>
            {/* define add,change,delete button */}
            <div className="Row">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                <Button className="Col-2-1" icon="add" onClick={() => buttonPress("new")} >New</Button>
                    <Alert
                        confirmButtonText="OK"
                        icon="disable"
                        intent={Intent.WARNING}
                        isOpen={isAdd}
                        onConfirm={ () => { setisAdd(false) } }
                    >
                        <p>
                            NEW : Access Denied
                        </p>
                    </Alert>
                <Button className="Col-3-1" icon="edit" onClick={() => buttonPress("edit")} >Edit</Button>
                    <Alert
                        confirmButtonText="OK"
                        icon="disable"
                        intent={Intent.WARNING}
                        isOpen={isEdit}
                        onConfirm={ () => { setisEdit(false) } }
                    >
                        <p>
                            EDIT : Access Denied
                        </p>
                    </Alert>
                <Button className="Col-4-1" icon="delete" onClick={() => buttonPress("delete")} >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDelete}
                        onCancel={ () => setisDelete(false) }
                        onConfirm={ () => { onDelete(); setisDelete(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Broker No." labelFor="inputBkCode" labelInfo="*">
                    <InputGroup readOnly value={Bkr.d_bkCode} />
                </FormGroup>
                <FormGroup className="Col-2-3" label="Broker Name" labelFor="inputBkName">
                    <InputGroup readOnly value={Bkr.d_bkName1} />
                    <InputGroup readOnly value={Bkr.d_bkName2} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-4" label="Address" labelFor="inputAddr1">
                    <InputGroup readOnly value={Bkr.d_bkAddr1} />
                    <InputGroup readOnly value={Bkr.d_bkAddr2} />
                    <InputGroup readOnly value={Bkr.d_bkAddr3} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-4" label="Ccass Part Id" labelFor="inputCcass_Part_Id">
                    <InputGroup readOnly value={Bkr.d_Ccass_Part_Id} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Telphone" labelFor="inputTel">
                    <InputGroup readOnly value={Bkr.d_Tel} />
                </FormGroup>
                <FormGroup className="Col-2-1" label="Fax No." labelFor="inputCcass_Part_Id">
                    <InputGroup readOnly value={Bkr.d_Fax} />
                </FormGroup>
                <FormGroup className="Col-3-3" label="Contact Persion" labelFor="inputContact_Persion">
                    <InputGroup readOnly value={Bkr.d_Contact_Persion} />
                </FormGroup>
            </div>

        </div>
    )
}


interface BkMastEditProps {
    gsb: AxiosInstance,
    Bkr?: BkInfo,
    isNew?: boolean,
    onSave?: (Bk: BkInfo) => void,
    onCancel?: () => void;
}

function BkMastEdit({ gsb, Bkr = {} as BkInfo, isNew = false, onSave = () => { }, onCancel = () => { } }: BkMastEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<BkInfo>()
    const { t, i18n } = useTranslation();    


    useEffect(() => {
        // Call reset to get the values of record StkInfo 
        if ("d_bkCode" in Bkr) {
            reset(Bkr)
        }
    }, [Bkr, reset])


    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
    

    if (! isNew && ! ("d_bkCode" in Bkr)) return null


    
    const onSubmit = (data: BkInfo) => {

        //console.log("BkMastEdit onsubmit data: ", data)

        // put value to json/field before write database dbf
        data.d_bkCode = data.d_bkCode.toUpperCase();

        (async () => {
            try {
                //console.log("call BkMastEdit data", data)
                //console.log("call BkMastEdit isNew", isNew)
                const res = await gsb.post('/Master', {sb_data: data, cPgmId: "Bkmast", cAction: "BkValidate", isNew: isNew})
                //console.log("BkMastEdit res.data.ok", res.data.ok)
                //console.log("BkMastEdit res.data.data", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }

                    return
                }

                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()

        //onSave(data)
    }



    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }


    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Broker No." labelFor="inputBkCode" labelInfo="*">
                    <InputGroup disabled={! isNew} id="inputBkCode" name="d_bkCode" autoFocus={isNew} defaultValue="" inputRef={register({ required: true , maxLength: 4 }) } />
                    {errors.d_bkCode && errors.d_bkCode.type === "required" && (<span id="Err_msg">Broker No. cannot be Blank</span>)}
                    {errors.d_bkCode && errors.d_bkCode.type === "maxLength" && <span id="Err_msg">Max length is 4</span>}
                    {errors.d_bkCode && errors.d_bkCode.types && <span id="Err_msg">{errors.d_bkCode.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-2" label="Broker Name" labelFor="inputBkName">
                    <InputGroup id="inputBkName" name="d_bkName1" autoFocus={! isNew} defaultValue="" placeholder="Broker Name ..." inputRef={register({ maxLength: 38}) } />
                    {errors.d_bkName1 && errors.d_bkName1.type === "maxLength" && <span id="Err_msg">Max length is 38</span>}
                    {errors.d_bkName1 && errors.d_bkName1.types && <span id="Err_msg">{errors.d_bkName1.types.message}</span>}
                    <InputGroup id="inputBkName" name="d_bkName2" defaultValue="" placeholder="Broker Name ..." inputRef={register({ maxLength: 38}) } />
                    {errors.d_bkName2 && errors.d_bkName2.type === "maxLength" && <span id="Err_msg">Max length is 38</span>}
                    {errors.d_bkName2 && errors.d_bkName2.types && <span id="Err_msg">{errors.d_bkName2.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-4" label="Address" labelFor="inputAddr1">
                    <InputGroup id="inputAddr1" name="d_bkAddr1" defaultValue="" placeholder="Address 1 ..." inputRef={register({ maxLength: 24}) } />
                    {errors.d_bkAddr1 && errors.d_bkAddr1.type === "maxLength" && <span id="Err_msg">Max length is 24</span>}
                    {errors.d_bkAddr1 && errors.d_bkAddr1.types && <span id="Err_msg">{errors.d_bkAddr1.types.message}</span>}
                    <InputGroup id="inputAddr2" name="d_bkAddr2" defaultValue="" placeholder="Address 2 ..." inputRef={register({ maxLength: 24}) } />
                    {errors.d_bkAddr2 && errors.d_bkAddr2.type === "maxLength" && <span id="Err_msg">Max length is 24</span>}
                    {errors.d_bkAddr2 && errors.d_bkAddr2.types && <span id="Err_msg">{errors.d_bkAddr2.types.message}</span>}
                    <InputGroup id="inputAddr3" name="d_bkAddr3" defaultValue="" placeholder="Address 3 ..." inputRef={register({ maxLength: 24}) } />
                    {errors.d_bkAddr3 && errors.d_bkAddr3.type === "maxLength" && <span id="Err_msg">Max length is 24</span>}
                    {errors.d_bkAddr3 && errors.d_bkAddr3.types && <span id="Err_msg">{errors.d_bkAddr3.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-4" label="Ccass Part Id" labelFor="inputCcass_Part_Id">
                    <InputGroup id="inputCcass_Part_Id" name="d_Ccass_Part_Id" defaultValue="" placeholder="Ccass Part Id ..." inputRef={register({ maxLength: 6}) } />
                    {errors.d_Ccass_Part_Id && errors.d_Ccass_Part_Id.type === "maxLength" && <span id="Err_msg">Max length is 6</span>}
                    {errors.d_Ccass_Part_Id && errors.d_Ccass_Part_Id.types && <span id="Err_msg">{errors.d_Ccass_Part_Id.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Telphone" labelFor="inputTel">
                    <InputGroup id="inputTel" name="d_Tel" defaultValue="" placeholder="Telphone ..." inputRef={register({ maxLength: 15}) } />
                    {errors.d_Tel && errors.d_Tel.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.d_Tel && errors.d_Tel.types && <span id="Err_msg">{errors.d_Tel.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-1" label="Fax No." labelFor="inputCcass_Part_Id">
                    <InputGroup id="inputCcass_Part_Id" name="d_Fax" defaultValue="" placeholder="Fax No. ..." inputRef={register({ maxLength: 15}) } />
                    {errors.d_Fax && errors.d_Fax.type === "maxLength" && <span id="Err_msg">Max length is 15</span>}
                    {errors.d_Fax && errors.d_Fax.types && <span id="Err_msg">{errors.d_Fax.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-3" label="Contact Persion" labelFor="inputContact_Persion">
                    <InputGroup id="inputContact_Persion" name="d_Contact_Persion" defaultValue="" placeholder="Contact Persion ..." inputRef={register({ maxLength: 30}) } />
                    {errors.d_Contact_Persion && errors.d_Contact_Persion.type === "maxLength" && <span id="Err_msg">Max length is 30</span>}
                    {errors.d_Contact_Persion && errors.d_Contact_Persion.types && <span id="Err_msg">{errors.d_Contact_Persion.types.message}</span>}
                </FormGroup>
            </div>

        </form>
    )
}

interface BkMastMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function BkMastMain({ gsb }: BkMastMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let { BkCode: defaultSearchValue = "" }: { BkCode: string } = useParams()

    const [data, setData] = useState([] as BkInfo[])

    const [searchKey, setSearchKey] = useState("Broker")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)

    const [showFilters, setShowFilters] = useState(false)

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentBk, setCurrentBk] = useState({} as BkInfo)
    const [BlankBk, setBlankBk] = useState({} as BkInfo)

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    

    //gsb default value

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("BkrMastMain disp user_key: ", res.data.Flag.user_key)
                //console.log("BkrMastMain disp MULTI_Bk: ", res.data.Flag.MULTI_Bk)
                //console.log("BkrMastMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("BkrMastMain disp GsbFlag: ", GsbFlag)
                //console.log("BkrMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("BkrMastMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("BkrMastMain disp GsbFlag.MULTI_Bk: ", sbFlag.MULTI_Bk)
                //console.log("BkrMastMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("BkrMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    const PrevRecProcess = async (Bkr: BkInfo) => {
        try {
            //console.log("call PrevRecProcess", Bkr)
            const res = await gsb.post('/Master', {sb_data: Bkr,  cPgmId: "Bkmast",cAction: "PrevRec"})
            //console.log("PrevRecProcess show 1: ", d_BkCode.d_StkNo)
            //console.log("PrevRecProcess data : ", data)
            //console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_bkCode === res.data.data.d_bkCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            //console.log("PrevRecProcess res.data.data : ", res.data.data)
            setCurrentBk(res.data.data)
            //console.log("PrevRecProcess show 2: ", stk.d_StkNo)
            setCurrentMode("show")
            //console.log("PrevRecProcess show 3: ", stk.d_StkNo)
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (Bkr: BkInfo) => {
        try {
            //console.log("call DeleteProcess", Bkr)
            const res = await gsb.post('/Master', {sb_data: Bkr, cPgmId: "Bkmast", cAction: "DelRec"})
            showSuccess("Broker No. " + Bkr.d_bkCode + " record deleted")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_bkCode === res.data.data.d_bkCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentBk(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (Bkr: BkInfo) => {
        try {
            //console.log("call NextRecProcess", Bkr)
            const res = await gsb.post('/Master', {sb_data: Bkr, cPgmId: "Bkmast", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_bkCode === res.data.data.d_bkCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentBk(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (Bkr: BkInfo) => {
        try {
            //console.log("call newOnSave", Bkr)
            const res = await gsb.post('/Master', {sb_data: Bkr, cPgmId: "Bkmast", cAction: "AddRec"})
            showSuccess("Broker No.  " + Bkr.d_bkCode + " record added")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_bkCode === res.data.data.d_bkCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentBk(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (Bkr: BkInfo) => {
        try {
            console.log("call editOnSave", Bkr)
            const res = await gsb.post('/Master', {sb_data: Bkr, cPgmId: "Bkmast", cAction: "UpdateRec"})
            showSuccess("Broker No.  " + Bkr.d_bkCode + " record saved")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_bkCode === res.data.data.d_bkCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            //console.log("editOnSave stk", Bkr)
            //console.log("editOnSave res.data.data", res.data.data)
            setCurrentBk(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }

        // get BkrMast list if searchKey have value
        try {
            //console.log("BkrMastMain onsubmit called", data)
            if ( m_limit > 1 ) {
                const res = await gsb.post('/Master',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                        }, 
                    },
                    cPgmId: "Bkmast",
                    cAction: "ListRec",
                });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentBk(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
    
            } else {
                const res = await gsb.post('/Master',
                {   sb_data: {
                        d_bkCode: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "Bkmast",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    //console.log("GetRec res.data.data", res.data.data)
                    setCurrentBk(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }

            setShowWait(false)
        } catch (error) {
            utils.showError(error)
        }
    }

    // get one SmMast record if StkNo have value
    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            // console.log("calling API for URL param");

            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 

            (async () => {
                //console.log("BkrMastMain useEffect length > 0  called", data)
                const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: "Broker",
                            start: defaultSearchValue,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "Bkmast",
                        cAction: "ListRec",
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentBk(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue])

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    //console.log("IntRMastMain useEffect nPage > 0  ", nPage)
                    const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                            }, 
                        },
                        cPgmId: "Bkmast",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setCurrentBk(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }


    // currentMode = show
    let detail = <BkMastView gsb={gsb} Bkr={currentBk} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentBk)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentBk)} onNextRec={() => NextRecProcess(currentBk)} ></BkMastView>
    switch (currentMode) {
        case "new":
            //console.log("currentMode = new")
            detail = <BkMastEdit gsb={gsb} Bkr={BlankBk} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } } ></BkMastEdit>
            break
        case "edit":
            //console.log("currentMode = edit")
            detail = <BkMastEdit gsb={gsb} Bkr={currentBk} onSave={editOnSave} onCancel={() => setCurrentMode("show")} ></BkMastEdit>
            break
        }

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>

    
    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-BrokerNo">Broker No</th>
                <th className="TCol-BkName1">Broker Name</th>
                <th className="TCol-Ccass_Part_Id">Broker Name 2</th>
                <th className="TCol-Tel">Telphone</th>
                <th className="TCol-Contact_Persion">Contact Persion</th>
            </thead>
            <tbody id="ma_tr">
                {data.map((Bk, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td className="TCol-BrokerNo" onClick={() => { setCurrentBk(Bk) ; MoblieDev && setSelectedTabId("detail") }}>{Bk.d_bkCode}</td>
                        <td className="TCol-BkName1" onClick={() => { setCurrentBk(Bk) ; MoblieDev && setSelectedTabId("detail") }}>{Bk.d_bkName1}</td>
                        <td className="TCol-Ccass_Part_Id" onClick={() => { setCurrentBk(Bk) }}>{Bk.d_Ccass_Part_Id}</td>
                        <td className="TCol-Tel" onClick={() => { setCurrentBk(Bk) }}>{Bk.d_Tel}</td>
                        <td className="TCol-Contact_Persion" onClick={() => { setCurrentBk(Bk) }}>{Bk.d_Contact_Persion}</td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    
    return (
        <>
            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >

                    {/* define search key */}
                    <H3><div style={{justifyContent: 'flex-end'}}>Broker Master</div></H3>
                    <div className="Row">
                        <FormGroup className="Col-1-5" label="Search for " labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="Broker">Broker No.</option>
                                    <option value="BkrName">Broker Name</option>
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "Broker"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "Broker"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>
                    </div>
                    <Collapse isOpen={showFilters}>
                        <div className="Row">
                            {/*
                            <FormGroup className="Col-5-2" label="No. of record(s) to List" labelFor="searchLimit" >
                                <InputGroup className="Input-XS" id="searchLimit" value={searchLimit.toString()} onChange={utils.handleNumberChange(n => setSearchLimit(n))} />
                            </FormGroup>
                            */}
                        </div>
                    </Collapse>
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card>

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default BkMastMain